/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ClientOnboardingDiscoverMaltStrategyJobStep = {
    NotStarted: 'NOT_STARTED',
    MaltStrategyDialog: 'MALT_STRATEGY_DIALOG',
    FindAMaltStrategy: 'FIND_A_MALT_STRATEGY',
    Done: 'DONE'
} as const;
export type ClientOnboardingDiscoverMaltStrategyJobStep = typeof ClientOnboardingDiscoverMaltStrategyJobStep[keyof typeof ClientOnboardingDiscoverMaltStrategyJobStep];


export function instanceOfClientOnboardingDiscoverMaltStrategyJobStep(value: any): boolean {
    for (const key in ClientOnboardingDiscoverMaltStrategyJobStep) {
        if (Object.prototype.hasOwnProperty.call(ClientOnboardingDiscoverMaltStrategyJobStep, key)) {
            // @ts-ignore
            if (ClientOnboardingDiscoverMaltStrategyJobStep[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ClientOnboardingDiscoverMaltStrategyJobStepFromJSON(json: any): ClientOnboardingDiscoverMaltStrategyJobStep {
    return ClientOnboardingDiscoverMaltStrategyJobStepFromJSONTyped(json, false);
}

export function ClientOnboardingDiscoverMaltStrategyJobStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientOnboardingDiscoverMaltStrategyJobStep {
    return json as ClientOnboardingDiscoverMaltStrategyJobStep;
}

export function ClientOnboardingDiscoverMaltStrategyJobStepToJSON(value?: ClientOnboardingDiscoverMaltStrategyJobStep | null): any {
    return value as any;
}

